<!-- ── SECTION 1: HERO ─────────────────────────────────────── -->
 <app-header-latest></app-header-latest>
<section class="att-hero">
  <div class="container-wrapper">
    <div>
      <div class="section-eyebrow" style="background:rgba(255,255,255,0.1);color:#fff;border-color:rgba(255,255,255,0.2);">📅 Attendance Intelligence</div>
      <h1>Time Tracking<br><span style="color:#6EE7B7;">Without the</span> Friction.</h1>
      <p>Smart clock-ins, biometric sync, shift management, and overtime auto-detection — built for every work style from remote to on-floor.</p>
      <div style="display:flex;gap:16px;">
        <a href="#" class="btn btn-white">Get Started Free</a>
        <a href="#" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.4);">Watch Demo</a>
      </div>
    </div>
    <div>
      <div class="clock-widget">
        <div class="clock-time">09 : 42 : 15</div>
        <div class="clock-date">Wednesday, January 15, 2025 — Working Day</div>
        <button class="clock-btn">✔ Clocked In — 09:01 AM</button>
        <div class="clock-list">
          <div class="clock-entry"><span>Sarah Jenkins</span><span class="clock-status">● Working</span></div>
          <div class="clock-entry"><span>Alex Chen</span><span class="clock-status">● Working</span></div>
          <div class="clock-entry"><span>Helen Lee</span><span style="color:#FCD34D;font-weight:700;">⏸ Break</span></div>
          <div class="clock-entry"><span>Tom Carter</span><span style="color:rgba(255,255,255,0.4);">○ Not In</span></div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ── SECTION 2: FEATURES STRIP ──────────────────────────── -->
<section class="att-features">
  <div class="container-wrapper">
    <div class="att-features__grid">
      <div class="att-feat-card"><div class="att-feat-card__icon">📱</div><div class="att-feat-card__title">Mobile Clock-In</div><div class="att-feat-card__desc">GPS-verified clock-ins from any device, anywhere in the world.</div></div>
      <div class="att-feat-card"><div class="att-feat-card__icon">🔍</div><div class="att-feat-card__title">Biometric Sync</div><div class="att-feat-card__desc">Connect fingerprint and face ID terminals to NeoHRMZ in real-time.</div></div>
      <div class="att-feat-card"><div class="att-feat-card__icon">🔔</div><div class="att-feat-card__title">Overtime Alerts</div><div class="att-feat-card__desc">Auto-flag overtime thresholds and send manager notifications instantly.</div></div>
      <div class="att-feat-card"><div class="att-feat-card__icon">📊</div><div class="att-feat-card__title">Attendance Reports</div><div class="att-feat-card__desc">Drill into attendance patterns, absences, and trends with one-click reports.</div></div>
    </div>
  </div>
</section>

<!-- ── SECTION 3: SHIFT CALENDAR ──────────────────────────── -->
<section class="calendar-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">📆 Shift Planner</span>
      <h2 class="sec-h2">Visual Shift Scheduling<br><span class="gradient-text">for Any Workforce</span></h2>
      <p class="sec-sub">See your team's coverage, shift types, and time-off at a glance — directly from the NeoHRMZ calendar.</p>
    </div>
    <div class="shift-calendar">
      <div class="cal-header">
        <div class="cal-header-day">Mon</div><div class="cal-header-day">Tue</div><div class="cal-header-day">Wed</div>
        <div class="cal-header-day">Thu</div><div class="cal-header-day">Fri</div><div class="cal-header-day">Sat</div><div class="cal-header-day">Sun</div>
      </div>
      <div class="cal-body">
        <div class="cal-cell"><div class="cal-date">13</div><span class="shift-dot day-shift">D-Shift</span></div>
        <div class="cal-cell"><div class="cal-date">14</div><span class="shift-dot day-shift">D-Shift</span></div>
        <div class="cal-cell today"><div class="cal-date">15</div><span class="shift-dot wfh">WFH</span></div>
        <div class="cal-cell"><div class="cal-date">16</div><span class="shift-dot night-shift">N-Shift</span></div>
        <div class="cal-cell"><div class="cal-date">17</div><span class="shift-dot day-shift">D-Shift</span></div>
        <div class="cal-cell"><div class="cal-date">18</div></div>
        <div class="cal-cell"><div class="cal-date">19</div></div>
        <div class="cal-cell"><div class="cal-date">20</div><span class="shift-dot day-shift">D-Shift</span></div>
        <div class="cal-cell"><div class="cal-date">21</div><span class="shift-dot day-shift">D-Shift</span></div>
        <div class="cal-cell"><div class="cal-date">22</div><span class="shift-dot wfh">WFH</span></div>
        <div class="cal-cell"><div class="cal-date">23</div><span class="shift-dot night-shift">N-Shift</span></div>
        <div class="cal-cell"><div class="cal-date">24</div><span class="shift-dot day-shift">D-Shift</span></div>
        <div class="cal-cell"><div class="cal-date">25</div></div>
        <div class="cal-cell"><div class="cal-date">26</div></div>
      </div>
    </div>
  </div>
</section>

<!-- ── SECTION 4: TEAM STATUS ──────────────────────────────── -->
<section class="status-board-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">🟢 Live Status</span>
      <h2 class="sec-h2">Real-Time<br><span class="gradient-text">Team Presence</span></h2>
      <p class="sec-sub">Always know who's in, on break, or out — updated live across all locations.</p>
    </div>
    <div class="team-status-grid">
      <div class="team-status-card"><div class="team-status-avatar"><div class="status-dot online"></div>SJ</div><div class="team-status-name">Sarah Jenkins</div><div class="team-status-info">Clocked In · 9:01 AM</div></div>
      <div class="team-status-card"><div class="team-status-avatar"><div class="status-dot online"></div>AC</div><div class="team-status-name">Alex Chen</div><div class="team-status-info">Clocked In · 8:47 AM</div></div>
      <div class="team-status-card"><div class="team-status-avatar"><div class="status-dot break"></div>HL</div><div class="team-status-name">Helen Lee</div><div class="team-status-info">On Break · Since 12:05 PM</div></div>
      <div class="team-status-card"><div class="team-status-avatar"><div class="status-dot out"></div>TC</div><div class="team-status-name">Tom Carter</div><div class="team-status-info">Approved Leave Today</div></div>
      <div class="team-status-card"><div class="team-status-avatar"><div class="status-dot online"></div>MB</div><div class="team-status-name">Marcus Brown</div><div class="team-status-info">Clocked In · 9:15 AM</div></div>
      <div class="team-status-card"><div class="team-status-avatar"><div class="status-dot online"></div>AM</div><div class="team-status-name">Alice Min</div><div class="team-status-info">Working Remotely</div></div>
      <div class="team-status-card"><div class="team-status-avatar"><div class="status-dot break"></div>KB</div><div class="team-status-name">Kevin Bacon</div><div class="team-status-info">Lunch Break · Since 1:00 PM</div></div>
      <div class="team-status-card"><div class="team-status-avatar"><div class="status-dot out"></div>SL</div><div class="team-status-name">Sam Long</div><div class="team-status-info">Clocked Out · 5:30 PM</div></div>
    </div>
  </div>
</section>

<!-- ── SECTION 5: BIOMETRIC ────────────────────────────────── -->
<section class="biometric-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow" style="color:rgba(255,255,255,0.7);">🔐 Hardware Integration</span>
      <h2 class="sec-h2" style="color:#fff;">Biometric Hardware<br><span style="color:#6EE7B7;">Plug & Play</span></h2>
      <p class="sec-sub" style="color:rgba(255,255,255,0.6);">Connect fingerprint scanners, face-ID kiosks, and RFID badge readers to NeoHRMZ in minutes.</p>
    </div>
    <div class="biometric-section__inner">
      <div class="biometric-section__list">
        <div class="biometric-section__feat"><div class="biometric-section__feat-icon">👆</div><div><div class="biometric-section__feat-title">Fingerprint Recognition</div><div class="biometric-section__feat-desc">ISO-certified fingerprint matching with 99.97% accuracy across all major terminal brands.</div></div></div>
        <div class="biometric-section__feat"><div class="biometric-section__feat-icon">👤</div><div><div class="biometric-section__feat-title">Face ID Kiosks</div><div class="biometric-section__feat-desc">Contactless face recognition kiosks for offices, factories, and hospitals with mask detection support.</div></div></div>
        <div class="biometric-section__feat"><div class="biometric-section__feat-icon">💳</div><div><div class="biometric-section__feat-title">RFID & NFC Badges</div><div class="biometric-section__feat-desc">Issue proximity cards and NFC employee badges with instant clock-in sync to your attendance dashboard.</div></div></div>
      </div>
      <div class="bio-device-card">
        <div class="bio-device-card__icon">🖥️</div>
        <div class="bio-device-card__title">NeoHRMZ Kiosk Terminal</div>
        <div class="bio-device-card__sub">Android-based, wall-mountable, POE-powered</div>
        <div class="bio-device-card__devices">
          <span class="bio-device-card__device-pill">ZKTeco</span>
          <span class="bio-device-card__device-pill">Anviz</span>
          <span class="bio-device-card__device-pill">Hikvision</span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ── SECTION 6: STATS + CTA ──────────────────────────────── -->
<section class="att-stats-section">
  <div class="container-wrapper">
    <div class="att-stats-section__grid">
      <div class="att-stat"><div class="att-stat__val">99.3%</div><div class="att-stat__lbl">Clock-In Accuracy Rate</div></div>
      <div class="att-stat"><div class="att-stat__val">12M+</div><div class="att-stat__lbl">Timesheets Processed Monthly</div></div>
      <div class="att-stat"><div class="att-stat__val">180+</div><div class="att-stat__lbl">Hardware Device Types Supported</div></div>
      <div class="att-stat"><div class="att-stat__val">0</div><div class="att-stat__lbl">Manual Errors with Auto-Sync</div></div>
    </div>
  </div>
</section>

<app-peopleflow-footer></app-peopleflow-footer>